import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import HizmetDetay from '../../components/HizmetDetay';
import camasirMakineResmi from '../../assets/camasir-makinesi-teknik-servis.webp';
import AOS from 'aos';
import 'aos/dist/aos.css';

function CamasirMakinesiServisi() {
  // --- AOS VE DİNAMİK BAŞLIK AYARI ---
  useEffect(() => {
    // Sekme ismini kesin olarak çakıyoruz
    document.title = "Ankara Çamaşır Makinesi Teknik Servis | Garantili Tamir";
    
    window.scrollTo(0, 0);
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  // --- GOOGLE İÇİN ÖZEL ÇAMAŞIR MAKİNESİ SERVİS ŞEMASI (JSON-LD) ---
  const washingMachineSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Çamaşır Makinesi Teknik Servis",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Ankara Merkez Teknik",
      "telephone": "+903125810881",
      "areaServed": "Ankara"
    },
    "description": "Ankara genelinde Arçelik, Samsung, Bosch ve LG başta olmak üzere tüm markalar için 7/24 garantili çamaşır makinesi tamiri. Kart tamiri, motor değişimi ve orijinal yedek parça.",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Çamaşır Makinesi Tamir Hizmetleri",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Pompa Motoru Değişimi" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Rulman ve Kazan Onarımı" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Elektronik Kart Tamiri" } }
      ]
    }
  };

  return (
    <>
      <Helmet>
        <title>Ankara Çamaşır Makinesi Teknik Servis | Garantili Tamir</title>
        <meta name="description" content="Ankara'da her marka çamaşır makinesi için 7/24 yerinde tamir hizmeti. Arçelik, Samsung, Bosch, LG servisi. 1 yıl parça garantili, uygun fiyatlı teknik servis!" />
        {/* Google botları için teknik veri */}
        <script type="application/ld+json">
          {JSON.stringify(washingMachineSchema)}
        </script>
      </Helmet>

      <div data-aos="fade-up">
        <HizmetDetay 
          icon="💧"
          baslik="Ankara Çamaşır Makinesi Teknik Servis"
          stat1="Uzman Tamir"
          stat2="Aynı Gün"
          resim={camasirMakineResmi}
          aciklama="Çamaşır makineniz su mu boşaltmıyor, sıkarken aşırı ses mi yapıyor veya kapağı mı kilitlendi? Ankara'nın tüm ilçelerine yayılan uzman ekiplerimizle arızaları yerinde ve garantili çözüyoruz."
          seoMetni={(
            <>
              {/* SEO KART 1: GENEL HİZMET */}
              <div className="editorial-card" data-aos="fade-right" data-aos-delay="100">
                <h4>Ankara Geneli Hızlı Çamaşır Makinesi Tamiri</h4>
                <p>
                  Kirli çamaşırların birikmesine izin vermiyoruz! Temel uzmanlığımız olan <strong>çamaşır makinesi teknik servis</strong> hizmetimizle <strong>ankara çamaşır makinesi servisi</strong> ağımızı tüm başkente yaydık. <strong>ankara çamaşır makinesi tamircisi</strong> olarak; <strong>çankaya</strong>, <strong>keçiören</strong>, <strong>yenimahalle</strong> ve <strong>altındağ</strong> bölgelerinde anında müdahale sağlıyoruz.
                </p>
              </div>

              {/* SEO KART 2: YERLİ MARKALAR */}
              <div className="editorial-card" data-aos="fade-left" data-aos-delay="200">
                <h4>Yerli Markalarda Orijinal Parça Güvencesi</h4>
                <p>
                  Evlerimizin vazgeçilmezi olan yerli cihazlarda <strong>arçelik çamaşır makinesi teknik servis</strong> ve <strong>beko çamaşır makinesi servisi ankara</strong> olarak 1 yıl parça garantili çalışıyoruz. <strong>vestel</strong>, <strong>profilo</strong>, <strong>altus</strong> ve <strong>regal</strong> işlemlerinizde şeffaf fiyatlandırma uyguluyoruz.
                </p>
              </div>

              {/* SEO KART 3: AVRUPA MARKALARI */}
              <div className="editorial-card" data-aos="fade-right" data-aos-delay="300">
                <h4>Alman Teknolojisi ve Lüks Segment Uzmanlığı</h4>
                <p>
                  Avrupa menşeli cihazların hassas yapıları profesyonellik ister. <strong>bosch çamaşır makinesi teknik servis</strong> ve <strong>siemens çamaşır makinesi tamircisi</strong> olarak her hata koduna hakimiz. <strong>miele</strong>, <strong>electrolux</strong> ve <strong>hotpoint ariston</strong> operasyonlarını titizlikle yürütüyoruz.
                </p>
              </div>

              {/* SEO KART 4: ASYA MARKALARI */}
              <div className="editorial-card" data-aos="fade-left" data-aos-delay="400">
                <h4>Güney Kore Teknolojisi ve İleri Elektronik Çözümleri</h4>
                <p>
                  Sessiz motor teknolojisine sahip cihazlarda <strong>samsung ankara çamaşır makinesi servisi</strong> ve <strong>lg çamaşır makinesi teknik servis</strong> standartlarını belirliyoruz. <strong>eryaman</strong>, <strong>sincan</strong> ve <strong>mamak</strong> bölgelerinde en zorlu rulman ve körük lastiği değişimlerini fabrikasyon kalitesinde yapıyoruz.
                </p>
              </div>
            </>
          )}
        />
      </div>
    </>
  );
}

export default CamasirMakinesiServisi;